import React from 'react';
import { Phone, CalendarCheck } from 'lucide-react';
import { businessInfo } from '../../data/mock';
import { useQuote } from '../../context/QuoteContext';

// Sticky click-to-call + quote bar, shown on mobile only.
const StickyCallBar = () => {
  const { openQuote } = useQuote();

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 md:hidden grid grid-cols-2 gap-px bg-[#1a1a1a] shadow-[0_-4px_20px_rgba(0,0,0,0.25)]"
      data-testid="sticky-call-bar"
    >
      <a
        href={`tel:${businessInfo.phone}`}
        className="flex items-center justify-center gap-2 bg-[#1a1a1a] text-white py-3.5 font-semibold active:bg-black"
        data-testid="sticky-call-button"
      >
        <Phone size={18} className="text-[#e85a24]" />
        Call Now
      </a>
      <button
        onClick={() => openQuote()}
        className="flex items-center justify-center gap-2 bg-[#e85a24] text-white py-3.5 font-semibold active:bg-[#d14a14]"
        data-testid="sticky-quote-button"
      >
        <CalendarCheck size={18} />
        Get a Quote
      </button>
    </div>
  );
};

export default StickyCallBar;
